import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import OstorlabMappingForm from "./OstorlabMappingForm";

const OstorlabCredentialsForm = (props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API URL",
      rules: [urlRegexValidator],
      required: true,
    },
    {
      name: "token",
      label: "API Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={OstorlabMappingForm}
    />
  );
};

export default forwardRef(OstorlabCredentialsForm);